import React from 'react';
import Forms from './components/Forms/Forms';
import ModalWindows from './components/ModalWindows/ModalWindows';
import EditDishState from './editDishState/EditDishState';
import EditDishControlPanel from './components/ControlPanel/ControlPanel';

const EditDishPage: React.FC = () => {
	return (
		<EditDishState>
			<EditDishControlPanel />
			<Forms />
			<ModalWindows />
		</EditDishState>
	);
};

export default EditDishPage;
